import { useTranslation } from "react-i18next";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import {Consts} from "../pages/consts";

const ImageFileUpload = ({ symptomNumber, onFilesChanged }) => {
  const { t } = useTranslation();
  const [thumbnails, setThumbnails] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileNames, setFileNames] = useState([]);
  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    const newThumbnails = newFiles?.map((file) => URL.createObjectURL(file));
    const newFileNames = newFiles?.map((file) => file.name);
    setThumbnails((prevThumbnails) => [...prevThumbnails, ...newThumbnails]);
    setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    onFilesChanged(symptomNumber, [...files, ...newFiles]);
  };

  const handleThumbnailClick = (thumbnail) => {
    setSelectedImage(thumbnail);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handleRemoveThumbnail = (index) => {
    const newThumbnails = thumbnails?.filter((_, i) => i !== index);
    const newFileNames = fileNames?.filter((_, i) => i !== index);
    const newFiles = files?.filter((_, i) => i !== index); // Entfernen der Datei
    setThumbnails(newThumbnails);
    setFileNames(newFileNames);
    setFiles(newFiles);
    onFilesChanged(symptomNumber, newFiles);
  };

  const uploadTooltip = `${t("add_related_images")} (${t("if_applicable")})`;
  const inputId = `image-file-upload-${symptomNumber}`;

  return (
    <>
      <div className="w3-row w3-padding-small symptom-images-header-row">
        <input
          id={inputId}
          type={Consts.FILE}
          accept="image/*"
          multiple
          onChange={handleFileChange}
          style={{ display: Consts.NONE }}
        />
        <label
          htmlFor={inputId}
          className="symptom-ui-button symptom-ui-button--primary symptom-ui-button--icon symptom-image-upload-label"
          title={uploadTooltip}
          aria-label={uploadTooltip}
        >
          <FontAwesomeIcon icon={faPlus} />
        </label>
      </div>
      <div className="w3-row w3-margin-top">
        {thumbnails?.map((thumbnail, index) => (
          <div key={index} className="w3-col s3 w3-border w3-margin-left">
            <FontAwesomeIcon
              icon={faXmark}
              onClick={() => handleRemoveThumbnail(index)}
              className="w3-right label-link"
            />
            <img
              src={thumbnail}
              alt={`${t("thumbnail")} ${index}`}
              className="w3-image w3-hover-opacity thumbnail"
              title={fileNames[index]}
              onClick={() => handleThumbnailClick(thumbnail)}
            />
          </div>
        ))}
      </div>
      {selectedImage && (
        <div className="image-fullscreen-container" onClick={handleCloseModal}>
          <img
            src={selectedImage}
            alt={t("selected")}
            className="image-fullscreen"
          />
          <div className="image-fullscreen-close">
            <label>{t("click_to_close")}</label>
          </div>
        </div>
      )}
      {thumbnails.length > 0 && (
        <div className="w3-row symptom-images-help-text-row">
          <label className="w3-small">{t("click_on_thumbnail_to_enlarge")}</label>
        </div>
      )}
    </>
  );
};

export default ImageFileUpload;
